import { AxiosWithCancelGet, ErrorHandler, IpHandler } from '@@types/Api';

import InterTenantChannelApi from '~/stores/providers/InterTenantApi/Channel';
import InterTenantCommonApi from '~/stores/providers/InterTenantApi/Common';
import InterTenantFileApi from '~/stores/providers/InterTenantApi/File';
import InterTenantLogApi from '~/stores/providers/InterTenantApi/Log';
import InterTenantMeApi from '~/stores/providers/InterTenantApi/Me';
import SharedChannelMemberApi from '~/stores/providers/InterTenantApi/Member';
import logging from '~/stores/providers/logging';
import { createRequester, getContents, getResult } from '~/utils/apiUtil';

class InterTenantApi {
  contentsRequester: AxiosWithCancelGet;
  resultRequester: AxiosWithCancelGet;
  ignoreErrorRequester: AxiosWithCancelGet;
  dataRequester: AxiosWithCancelGet;
  errorHandler: ErrorHandler = (error: Error) => {
    logging.log('[Default Error Handler] error', error);
  };

  ipHandler: IpHandler = () => {};

  channel: InterTenantChannelApi;
  member: SharedChannelMemberApi;
  log: InterTenantLogApi;
  me: InterTenantMeApi;
  common: InterTenantCommonApi;
  file: InterTenantFileApi;

  initialize = () => {
    this.makeRequester();

    this.channel = new InterTenantChannelApi(this);
    this.member = new SharedChannelMemberApi(this);
    this.log = new InterTenantLogApi(this);
    this.me = new InterTenantMeApi(this);
    this.common = new InterTenantCommonApi(this);
    this.file = new InterTenantFileApi(this);
  };

  setErrorHandler = (errorHandler: ErrorHandler) => {
    this.errorHandler = errorHandler;
    this.makeRequester();
  };

  makeRequester = () => {
    this.contentsRequester = createRequester(this.errorHandler, this.ipHandler, { unWrapper: getContents });
    this.resultRequester = createRequester(this.errorHandler, this.ipHandler, { unWrapper: getResult });
    this.ignoreErrorRequester = createRequester(this.errorHandler, this.ipHandler, { ignoreError: true });
    this.dataRequester = createRequester(this.errorHandler, this.ipHandler, {});
  };
}

export default InterTenantApi;

export const interTenantApi = new InterTenantApi();
